import { NSAHomePage, NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { ErpLayout } from "../ErpLayout";
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpRoutes } from "../ErpRoutes";
import { ErpScopeMode } from "../ErpScope";
import { NSModuleBoard, NSModuleBoardSectionProps } from "../components/NSModuleBoard";

interface HomePageProps extends NSARouterMakerResult, ErpRouterProps { }

const icons = {
    currency: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="9" />
            <path d="M15 8.5c-.7-.9-1.8-1.5-3-1.5-2 0-3.5 1.1-3.5 2.5S10 12 12 12s3.5 1.1 3.5 2.5S14 17 12 17c-1.3 0-2.4-.6-3-1.5" />
            <path d="M12 5v2M12 17v2" />
        </svg>
    ),
    exchange: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 8h13l-3-3" />
            <path d="M20 16H7l3 3" />
        </svg>
    ),
    company: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="4" width="18" height="17" rx="2" />
            <path d="M8 9h2M8 13h2M8 17h2M14 9h2M14 13h2M14 17h2" />
        </svg>
    ),
    branch: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="6" cy="6" r="2" />
            <circle cx="6" cy="18" r="2" />
            <circle cx="18" cy="12" r="2" />
            <path d="M6 8v8M8 6c6 0 4 6 8 6M8 18c6 0 4-6 8-6" />
        </svg>
    ),
    calendar: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="5" width="18" height="16" rx="2" />
            <path d="M3 10h18M8 3v4M16 3v4" />
        </svg>
    ),
    account: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 7h18M3 12h18M3 17h12" />
            <circle cx="18" cy="17" r="2" />
        </svg>
    ),
    party: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="9" cy="8" r="3" />
            <circle cx="17" cy="10" r="2.5" />
            <path d="M3 20c0-3 2.5-5 6-5s6 2 6 5" />
            <path d="M15 20c0-2 1.5-3.5 4-3.5s2 1.5 2 3.5" />
        </svg>
    ),
    tag: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 12V4h8l10 10-8 8L3 12z" />
            <circle cx="7.5" cy="7.5" r="1.5" />
        </svg>
    ),
    journal: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 4h11l3 3v13H5z" />
            <path d="M8 10h8M8 14h8M8 18h5" />
        </svg>
    ),
    lock: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="5" y="11" width="14" height="10" rx="2" />
            <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        </svg>
    ),
    approval: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="9" />
            <path d="M8 12l3 3 5-6" />
        </svg>
    ),
    ledger: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 4v16h16" />
            <path d="M8 16l3-4 3 3 4-6" />
        </svg>
    ),
    balance: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 3v18" />
            <path d="M4 8h16" />
            <path d="M7 8l-3 6a3 3 0 0 0 6 0z" />
            <path d="M17 8l-3 6a3 3 0 0 0 6 0z" />
        </svg>
    ),
    vehicle: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 13l2-5a2 2 0 0 1 2-1h10a2 2 0 0 1 2 1l2 5" />
            <path d="M3 13h18v4a1 1 0 0 1-1 1h-2v-2H6v2H4a1 1 0 0 1-1-1z" />
            <circle cx="7" cy="16" r="1.5" />
            <circle cx="17" cy="16" r="1.5" />
        </svg>
    ),
    serviceType: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
        </svg>
    ),
    maintenance: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.7 6.3a5 5 0 0 0-6.4 6.4L3 18l3 3 5.3-5.3a5 5 0 0 0 6.4-6.4l-3 3-2.3-2.3z" />
        </svg>
    ),
    service: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 3h6l1 3h3v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6h3z" />
            <path d="M9 12l2 2 4-4" />
        </svg>
    ),
    odometer: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 12a9 9 0 0 1 18 0" />
            <path d="M12 12l4-3" />
            <circle cx="12" cy="12" r="1.5" />
            <path d="M5 12h1M18 12h1M12 6v1" />
        </svg>
    ),
    fuel: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16" />
            <path d="M5 21h10" />
            <path d="M15 9h2a2 2 0 0 1 2 2v6a1.5 1.5 0 0 0 3 0V7l-2-2" />
            <path d="M8 8h4" />
        </svg>
    ),
    refueling: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 20V6a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v14" />
            <path d="M4 20h11" />
            <path d="M15 10h2a2 2 0 0 1 2 2v4a2 2 0 0 0 2 2" />
            <path d="M7 8l3 3-3 3" />
        </svg>
    ),
};

const sections: NSModuleBoardSectionProps[] = [
    {
        title: "International",
        accentFrom: "#06b6d4",
        accentTo: "#0ea5e9",
        iconBg: "#e0f7fa",
        iconColor: "#0891b2",
        items: [
            { title: "Currency", hint: "Manage currencies", href: ErpRoutes.CurrencyList, icon: icons.currency },
            { title: "Currency Exchange", hint: "Exchange rates", href: ErpRoutes.CurrencyExchangeList, icon: icons.exchange },
        ],
    },
    {
        title: "Organization",
        accentFrom: "#8b5cf6",
        accentTo: "#6366f1",
        iconBg: "#ede9fe",
        iconColor: "#6d28d9",
        items: [
            { title: "Company", hint: "Legal entities", href: ErpRoutes.CompanyList, icon: icons.company },
            { title: "Branch", hint: "Locations", href: ErpRoutes.BranchList, icon: icons.branch },
            { title: "Fiscal Year", hint: "Accounting periods", href: ErpRoutes.FiscalYearList, icon: icons.calendar },
        ],
    },
    {
        title: "Accounting",
        accentFrom: "#10b981",
        accentTo: "#059669",
        iconBg: "#d1fae5",
        iconColor: "#047857",
        items: [
            { title: "Account", hint: "Chart of accounts", href: ErpRoutes.AccountList, icon: icons.account },
            { title: "Party", hint: "Customers & vendors", href: ErpRoutes.PartyList, icon: icons.party },
            { title: "Tag", hint: "Classification", href: ErpRoutes.TagList, icon: icons.tag },
            { title: "Journal Entry", hint: "Post transactions", href: ErpRoutes.JournalEntryList, icon: icons.journal },
            { title: "Journal Entry Request", hint: "Propose entries for approval", href: ErpRoutes.JournalEntryRequestNew, icon: icons.journal },
            { title: "Lock", hint: "Period locks", href: ErpRoutes.LockList, icon: icons.lock },
            { title: "General Ledger", hint: "Detailed ledger", href: ErpRoutes.ReportGeneralLedger, icon: icons.ledger },
            { title: "Balance Sheet", hint: "Financial position", href: ErpRoutes.ReportBalanceSheet, icon: icons.balance },
            { title: "Approval Requests", hint: "Approve or reject requests", href: ErpRoutes.ReportJournalEntryRequest, icon: icons.approval },
        ],
    },
    {
        title: "Canadian GIFI",
        accentFrom: "#f59e0b",
        accentTo: "#ef4444",
        iconBg: "#fff7ed",
        iconColor: "#b45309",
        items: [
            { title: "GIFI Codes", hint: "CRA RC4088 reference", href: ErpRoutes.GifiList, icon: icons.ledger },
            { title: "GIFI Report", hint: "Aggregate by GIFI", href: ErpRoutes.ReportGifi, icon: icons.balance },
        ],
    },
    {
        title: "Fleet Management",
        accentFrom: "#0ea5e9",
        accentTo: "#2563eb",
        iconBg: "#dbeafe",
        iconColor: "#1d4ed8",
        items: [
            { title: "Service Type", hint: "Types of service", href: ErpRoutes.ServiceTypeList, icon: icons.serviceType },
            { title: "Fuel", hint: "Fuel types", href: ErpRoutes.FuelList, icon: icons.fuel },
            { title: "Vehicle", hint: "Fleet vehicles", href: ErpRoutes.VehicleList, icon: icons.vehicle },
            { title: "Odometer", hint: "Mileage readings", href: ErpRoutes.OdometerList, icon: icons.odometer },
            { title: "Refueling", hint: "Refueling records", href: ErpRoutes.RefuelingList, icon: icons.refueling },
            { title: "Maintenance Plan", hint: "Preventive schedules", href: ErpRoutes.MaintenancePlanList, icon: icons.maintenance },
            { title: "Service", hint: "Service records", href: ErpRoutes.ServiceList, icon: icons.service },
        ],
    },
];

class HomePage extends Component<HomePageProps>
{
    override render()
    {
        return (
            <ErpLayout {...this.props} mode={ErpScopeMode.None}>
                <NSAHomePage
                    {...this.props}
                    product={{ search: true }}
                    getChildren={{
                        getChildrenBefore: () => <NSModuleBoard sections={sections} />,
                    }}
                />
            </ErpLayout>
        );
    }
}

export default HomePage;